export const INIZIALIZZA = "INIZIALIZZA";
export const LOADING_OVERLAY = "LOADING_OVERLAY";
export const SELECT_SCOPE_AMLETO = "SELECT_SCOPE_AMLETO";
export const AGENZIA_NON_ADEGUATA_ORIGINI_FONDI = "AGENZIA_NON_ADEGUATA_ORIGINI_FONDI";
export const SCOPE_TCM_EMISSIONE = "SCOPE_TCM_EMISSIONE"; 
export const TCM_INDIVIDUALE_VALIDA = "TCM_INDIVIDUALE_VALIDA";
export const TAB_SELEZIONATO_CONTRANTE = "TAB_SELEZIONATO_CONTRANTE"; // 0 - Contraente Fisico, 1 Contraente Giuridico